import React from 'react';
import Container from '../../../containers/master/scholastics/createScholasticContainer';

export default function () {
  return (
    <Container />
  );
}
